var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"heart",class:{ 
	    'like' : _vm.heart.level === 1, 
	    'love' : _vm.heart.level === 2, 
	    'stalker' : _vm.heart.level === 3 
	   },attrs:{"href":"javascript:void(0)"},on:{"click":function($event){_vm.handleHeart()}}},[_c('i',[_vm._v("♥")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e15c37a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/pv/heart.vue
// module id = null
// module chunks = 